import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

type Props = {
  id?: string;

  icon: IconDefinition;
  iconColor: string;

  borderColor: string;
};

export const MapMarker: React.FC<Props> = ({ id, icon, iconColor, borderColor }) => {
  return (
    <div style={{ position: "relative", display: "inline-block", pointerEvents: "none" }}>
      <div
        id={id}
        style={{
          pointerEvents: "none",
          width: 28,
          height: 28,
          borderRadius: 999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
          border: `2px solid ${borderColor}`,
          boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
        }}
      >
        <FontAwesomeIcon icon={icon} style={{ color: iconColor, fontSize: 14 }} />
      </div>
    </div>
  );
};
